module.exports = __webpack_public_path__ + "img/vender2.5b0410a3.png";